import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { IDowntimeSavedProps } from "./DowntimeSavedInterfaces";
import { BreadcrumbsList } from "../BreadcrumbsList/BreadcrumbsList.view";
import { HMIContext } from "../../../../../../contexts/HMIContext/HMIContext";
import { MachineCenterContext } from "contexts/MachineCenterContext/MachineCenterContext";
import { HMICachedDataContext } from "contexts/HMICachedDataContext/HMICachedDataContext";
import { useTranslation } from "react-i18next";
import { useStyles } from "./DowntimeSaved.styles";
import { DOWNTIMEMETHODCAPTURE } from "constants/constants";

export const DowntimeSaved = ({ failureType, area, functionalLocation, failureCode, notes }: IDowntimeSavedProps) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { failureDetailsStep } = useContext(HMIContext);
    const { plc } = useContext(MachineCenterContext);
    const { store } = useContext(HMICachedDataContext);

    return (
        <Box className={classes.downtimeSavedContainer}>
            <Box>
                {store.machineCenter?.downtime_method_capture_id === DOWNTIMEMETHODCAPTURE.PLC && plc ? (
                    <img src="/images/downtime_saved_plc.svg" alt="downtime saved plc" />
                ) : (
                    <img src="/images/downtime_saved_manual.svg" alt="downtime saved manual" />
                )}
                <Typography variant="h1" className={classes.title}>
                    {t("HMI.failure_details.downtime_saved.title")}
                </Typography>
                <Typography variant="subtitle1" className={classes.subtitle}>
                    {plc && store.machineCenter?.downtime_method_capture_id === DOWNTIMEMETHODCAPTURE.PLC
                        ? t("HMI.failure_details.downtime_saved.reactivate_machine_plc")
                        : t("HMI.failure_details.downtime_saved.reactivate_machine_manual")}
                </Typography>
            </Box>
            <Box className={classes.summaryBox}>
                <Box className={classes.summarySection}>
                    <Typography variant="subtitle2" className={classes.summaryTitle}>
                        {t("HMI.failure_details.downtime_saved.selections").toUpperCase()}
                    </Typography>
                    <BreadcrumbsList
                        failureType={failureType}
                        area={area}
                        functionalLocation={functionalLocation}
                        failureCode={failureCode}
                        failureDetailsStep={failureDetailsStep}
                    />
                </Box>
                {notes && (
                    <Box className={classes.summarySection}>
                        <Typography variant="subtitle2" className={classes.summaryTitle}>
                            {t("HMI.failure_details.downtime_saved.notes").toUpperCase()}
                        </Typography>
                        <Typography variant="subtitle1" className={classes.summaryNotes}>
                            {notes}
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};
